<template>
  <div>
    <b-form-group
      label="Başlık"
      label-for="title"
    >
      <b-form-input
        id="title"
        v-model="itemData.translate.title"
        placeholder="Başlık"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.title }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Adres 1"
      label-for="title"
    >
      <b-form-input
        id="title"
        v-model="itemData.translate.line1"
        placeholder="Adres 1"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.line1 }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Adres 2"
      label-for="title"
    >
      <b-form-input
        id="title"
        v-model="itemData.translate.line2"
        placeholder="Adres 2"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.line2 }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Adres 3"
      label-for="title"
    >
      <b-form-input
        id="title"
        v-model="itemData.translate.line3"
        placeholder="Adres 3"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.line3 }}
        </div>
      </b-alert>
    </b-form-group>
    <b-button
      variant="primary"
      size="sm"
      @click="saveAction"
    >
      <FeatherIcon icon="SaveIcon" />
      Kaydet
    </b-button>
  </div>
</template>
<script>
import {
  BFormGroup, BFormInput, BAlert, BButton,
} from 'bootstrap-vue'

export default {
  name: 'FooterContracts',
  components: {
    BFormGroup,
    BFormInput,
    BAlert,
    BButton,
  },
  props: {
    saveAction: {
      type: Function,
      require: true,
    },
  },
  computed: {
    itemData() {
      return this.$store.getters['translate/dataItem']
    },
  },
}
</script>
